/**
 * User-facing Hirelane copy for canonical pipeline `status` values from API/DB.
 */
const PIPELINE_STAGE_LABELS = {
  New: 'New',
  'Cony Reviewed': 'Cony reviewed',
  'Under Review': 'Under review',
  'Needs Clarification': 'Needs clarification',
  'Hold Profile': 'Hold (profile)',
  Shortlisted: 'Shortlisted',
  'Round Cleared': 'Round cleared',
  'Hold Pipeline': 'Hold (pipeline)',
  'Interview Scheduled': 'Interview scheduled',
  Rejected: 'Rejected',
  Selected: 'Selected'
};

export function hirelanePipelineStageLabel(status) {
  if (status == null || status === '') return '';
  return PIPELINE_STAGE_LABELS[status] ?? String(status);
}
